module.exports = __webpack_public_path__ + "static/src/content/images/processed/200/Valkyrie.75d7a93.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/content/images/processed/200/Valkyrie.jpg
// module id = J1jL
// module chunks = 0